import { sql } from "drizzle-orm";

import { executeQuery, type Tx } from "@/db/drizzleUtils";
import { feed, workspaceCommandAlias } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";

export async function initializeIsAliasFeed(tx?: Tx): Promise<void> {
  const rawSQL = sql`
  with alias_feed as (
    select ${feed.id} as id, ${workspaceCommandAlias.workspaceMembershipId} as workspaceMembershipId
    from ${feed}
    inner join ${workspaceCommandAlias} on ${feed.id} = ${workspaceCommandAlias.feedId}
  )
  update ${feed}
  set "isAliasFeed" = true, "aliasMembershipId" = alias_feed.workspaceMembershipId
  from alias_feed
  where ${feed.id} = alias_feed.id 
  
  `;

  await executeQuery(rawSQL, "initializeIsAliasFeed", tx);
}

export async function initializeIsAliasFeedFromIds(feedIds: string[], tx?: Tx): Promise<void> {
  const deduped = deduplicateByKeyValue(feedIds, (id) => id);
  if (deduped.length === 0) return;
  const feedIdList = sql.join(
    deduped.map((id) => sql`${id}`),
    sql`, `,
  );
  const rawSQL = sql`
  with alias_feed as (
    select ${feed.id} as id, ${workspaceCommandAlias.workspaceMembershipId} as workspaceMembershipId
    from ${feed}
    inner join ${workspaceCommandAlias} on ${feed.id} = ${workspaceCommandAlias.feedId}
    where ${feed.id} in (${feedIdList})
  )
  update ${feed}
  set "isAliasFeed" = true, "aliasMembershipId" = alias_feed.workspaceMembershipId
  from alias_feed
  where ${feed.id} = alias_feed.id
  `;

  await executeQuery(rawSQL, "initializeIsAliasFeed", tx);
}
